import { ArrowUpRight, Check } from "lucide-react";
import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";

const Paths = () => {
  const { t } = useLang();
  const c = t.paths.card;
  return (
    <section data-testid="paths-section" className="border-t border-ink/10 bg-sand py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="mx-auto flex max-w-2xl flex-col items-center text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-clay">{t.paths.overline}</p>
          <h2 data-testid="paths-heading" className="mt-6 font-serif text-4xl tracking-tight text-ink sm:text-5xl">
            {t.paths.h2a} <em className="italic text-clay">{t.paths.h2b}</em>
          </h2>
          <p className="mt-6 text-base leading-relaxed text-ink/60">{t.paths.sub}</p>
        </Reveal>

        <Reveal delay={0.12} className="mx-auto mt-16 max-w-3xl">
          <div
            id="for-wholesalers"
            data-testid="path-card-wholesalers"
            className="group flex h-full flex-col border border-ink/10 bg-bone p-10 transition-shadow duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.08)] md:p-14"
          >
            <h3 className="font-serif text-3xl tracking-tight text-ink md:text-4xl">{c.title}</h3>
            <p className="mt-3 font-serif text-lg italic text-clay">{c.sub}</p>
            <ul className="mt-8 flex flex-col gap-4">
              {c.points.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm leading-relaxed text-ink/70">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={2.5} />
                  {p}
                </li>
              ))}
            </ul>
            <div className="mt-10 grid grid-cols-2 gap-6 border-t border-ink/10 pt-6">
              <div>
                <p className="text-[11px] uppercase tracking-[0.2em] text-ink/40">{c.moqL}</p>
                <p className="mt-1 font-serif text-lg text-ink">{c.moqV}</p>
              </div>
              <div>
                <p className="text-[11px] uppercase tracking-[0.2em] text-ink/40">{c.leadL}</p>
                <p className="mt-1 font-serif text-lg text-ink">{c.leadV}</p>
              </div>
            </div>
            <a
              href="#quote"
              data-testid="path-cta-wholesalers"
              className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-ink px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.14em] text-bone transition-colors duration-300 hover:bg-clay"
            >
              {c.cta}
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 rtl:rotate-[-90deg]" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Paths;
